import parsePhoneNumber from './parsePhoneNumber'

const formatPhoneNumber = (numberString) => {
  // parsePhoneNumber strips formatting and any country-code prefix, leaving
  // the 10-digit national number (or fewer digits for partial values).
  const nationalNumber = parsePhoneNumber(numberString)

  // Partial numbers (fewer than 10 digits) won't match and are returned unformatted.
  return nationalNumber.replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3')
}

export default formatPhoneNumber
